import TDefaultLayout from './index.vue';

TDefaultLayout.install = app => {
  app.component(TDefaultLayout.name, TDefaultLayout);
};

export default TDefaultLayout;
